import { supabase } from '../config/supabase';

export const userService = {
  // Get user profile
  getProfile: async (userId) => {
    const { data, error } = await supabase
      .from('cashflow_users_a7b9c3d2e1')
      .select('*')
      .eq('id', userId)
      .single();
    
    if (error) throw error;
    return data;
  },
  
  // Get all users (admin only)
  getAllUsers: async () => {
    const { data, error } = await supabase
      .from('cashflow_users_a7b9c3d2e1')
      .select('*')
      .order('name');
    
    if (error) throw error;
    return data;
  },
  
  // Create user profile after registration
  createProfile: async (userId, profile) => {
    const { data, error } = await supabase
      .from('cashflow_users_a7b9c3d2e1')
      .insert([{
        id: userId,
        name: profile.name,
        email: profile.email,
        role: profile.role || 'user'
      }]);
    
    if (error) throw error;
    return data;
  }
};